import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_org/policies")({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();
  const navigate = Route.useNavigate();

  if (location.pathname === "/policies") {
    return navigate({
      to: "/policies/expense",
    });
  }
  return <Outlet />;
}
